export default "__VITE_ASSET__BlXBdqNW__"